import React from "react"
import Layout from "../components/layout"

import SEO from "../components/seo"

import Header from "./../components/header"
import Banner from "../components/banner"
import News from "../components/news"
import Depoimentos from "../components/depoimentos"
import Ux from "../components/ux"
import Band from "../components/band"
import Design from "../components/design"
import Arquitetura from "../components/arquitetura"
import Dev from "../components/dev"


class IndexPage extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      showContact: false,
      showTutorial: false,
      classMenu: ''
    }
    this.handleContact = this.handleContact.bind(this)
    this.handleTutorial = this.handleTutorial.bind(this)
    this.handleClassMenu = this.handleClassMenu.bind(this)
  }
  handleContact(){
    const showContact = !this.state.showContact
    this.setState({
      showContact
    })
  }
  handleClassMenu(){
    const classMenu = this.state.classMenu === 'show' ? '' : 'show'
    this.setState({
      classMenu
    })
  }
  handleTutorial(){
    const showTutorial = !this.state.showTutorial
    this.setState({
      showTutorial
    })
  }
  render(){
    return(
      <>
       <Header handle={this.handleContact} handleMenu={this.handleClassMenu} classTmp={this.state.classMenu} />
        <Layout>
          <SEO title="Sistema de Gestão Comercial Online com NF-e - TagPlus NF-e" />
          <Banner handle={this.handleContact} />
          <News />
          <Depoimentos />
          <Ux />
          <Design />
          <Arquitetura />
          <Dev />
          <Band />
        </Layout>
      </>
    )
  }
}

export default IndexPage
